import { render, staticRenderFns } from "./ManutencaoCarrosView.vue?vue&type=template&id=778869ee&"
import script from "./ManutencaoCarrosView.vue?vue&type=script&lang=ts&"
export * from "./ManutencaoCarrosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports